<template>
  <div>
    <Card>
      <p slot="title"> List Nota Transaksi Penyesuaian </p>
      <Row type="flex" justify="space-between">
        <Col span="10">
          <ButtonGroup class="custom-group-parent">
              <Button class="custom-group">Kode Penyesuian</Button>
              <Select
                v-model="categoryId"
                placeholder="Select"
                clearable
                filterable
                @on-change="updateFilter">
                  <Option
                      v-for="category in categories"
                      :value="category.id"
                      :key="category.id">{{ category.category }}</Option>
              </Select>
          </ButtonGroup>
        </Col>

        <Col span="10">
          <ButtonGroup class="custom-group-parent">
              <Button class="custom-group">Kode Nota</Button>
              <Input style="width: 100%;" v-model="filterNoteCode" @on-keyup="updateFilter"></Input>
          </ButtonGroup>
        </Col>

        <Col span="3">
            <Button type="primary" icon="ios-search" @click="getTransactionNoteAdjustment" :disabled="!isSearchShow">
              <span>Cari</span>
            </Button>
        </Col>
      </Row>

      <br />

      <Row type="flex" justify="space-between">
        <Col span="10">
          <ButtonGroup class="custom-group-parent">
              <Button class="custom-group">Tgl. Transaksi</Button>
              <Date-picker
                  v-model="filterTransactionDate"
                  style="width: 100%;"
                  type="daterange"
                  format="yyyy-MM-dd"
                  @on-change="updateFilter">
              </Date-picker>
          </ButtonGroup>
        </Col>

        <Col span="10">
            <ButtonGroup class="custom-group-parent">
                <Button class="custom-group">Marking &nbsp;&nbsp;&nbsp;</Button>
                <Select
                    style="width: 100%;"
                    v-model="markingIdSelected"
                    filterable
                    clearable
                    :remote-method="getMarkingByCode"
                    :loading="isLoadingMarking"
                    @on-change="updateFilter">
                    <Option v-for="option in optionMarkings"
                        :value="option.value" :key="option.value">{{option.label}}</Option>
                </Select>
            </ButtonGroup>
        </Col>

        <Col span="3">
            <Spin size="large" v-show="isLoadingMarking"></Spin>
        </Col>
      </Row>

      <br/>

      <Card>
          <Table :columns="columnsDataTable" :data="transactionNoteData" @on-selection-change="onSelectionChange"></Table>
      </Card>
    </Card>

    <div class="footer" v-show="transactionNotePrint.length > 0">
        <Button
            type="success"
            @click="showModalConfirmMultiplePrint(transactionNotePrint)"
            icon="printer"
            size="small"  >
                <span>Cetak {{ transactionNotePrint.length }} data</span>
        </Button>
        <!-- <Button
            type="error"
            @click="modalConfirmMultipleDelete = true"
            icon="trash-b"
            size="small"  >
                <span>Hapus {{ transactionNotePrint.length }} data</span>
        </Button> -->
    </div>

    <!-- table-sheet hidden -->
    <div id="table-to-excel" ref="sheetsDataTableList" hidden></div>

    <!-- Modal Confirm Multiple Print -->
    <Modal v-model="modalConfirmMultiplePrint" width="50rem">
        <p slot="header" style="color:#19be6b;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Konfirmasi Cetak Data</span>
        </p>
        <div style="text-align:center; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr));">
            <div v-for="data in transactionNotePrint">
                <Tag color="blue" style="width: 8rem;">{{ data.noteCode }}</Tag>
            </div>
        </div>
        <div slot="footer">
            <Button
                type="success" size="large" long icon="printer"
                :loading="isPrinting"
                @click="notePrint(transactionNotePrint)"
                >Cetak</Button>
        </div>
    </Modal>

    <!-- Modal Confirm Multiple Delete -->
    <Modal v-model="modalConfirmMultipleDelete" width="50rem">
        <p slot="header" style="color:#ed3f14;text-align:center">
            <Icon type="information-circled"></Icon>
            <span>Konfirmasi Hapus Data</span>
        </p>
        <div style="text-align:center; display: grid; grid-template-columns: repeat(4, minmax(0, 1fr));">
            <div v-for="data in transactionNotePrint">
                <Tag color="blue" style="width: 8rem;">{{ data.noteCode }}</Tag>
            </div>
        </div>
        <div slot="footer">
            <Button
                type="error" size="large" long icon="trash-b"
                :loading="isDelete"
                @click="noteDelete(transactionNotePrint)"
                >Hapus</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'

const numeral = require('numeral');
const formatter = new Intl.NumberFormat('en', {
  style: 'decimal',
});

export default {
    data () {
        return {
            categories: [],
            categoryId: null,
            filterTransactionDate: [],
            filterNoteCode: '',
            markingIdSelected: '',
            isSearchShow: false,
            optionMarkings: [],
            isLoadingMarking: false,
            columnsDataTable: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: 'Kode Nota',
                    key: 'noteCode'
                },
                // {
                //     title: 'Tipe',
                //     key: 'type'
                // },
                {
                    title: 'Tgl. Pembayaran',
                    key: 'paymentDate'
                },
                {
                    title: 'Mutasi',
                    key: 'amount'
                },
                // {
                //     title: 'Bank',
                //     key: 'bankAccount'
                // },
                {
                    title: 'Marking',
                    key: 'marking'
                }
            ],
            transactionNoteData: [],
            transactionNotePrint: [],
            modalConfirmMultiplePrint: false,
            modalConfirmMultipleDelete: false,
            isPrinting: false,
            isDelete: false
        }
    },
    methods: {
        showDateFormatted : function(stringToFormat){
          let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
          return moment(dateToFormat).format("DD MMM YYYY")
        },
        totalAmount(transaction_note_adjustment_details) {
          // Use reduce to sum the amount field
          return transaction_note_adjustment_details.reduce((sum, detail) => {
            return sum + parseFloat(detail.payment[0].amount);
          }, 0);
        },
        getCategories: function() {
            HTTP.get("category/adjustment")
            .then(response => {
              this.categories = response.data;
            })
            .catch(e => {
              this.$Notice.error({
                title: "Error",
                desc: e,
                duration: 5
              });
            });
        },

        getMarkingByCode: _.debounce(
            function (query) {
                if (query !== '') {
                    this.isLoadingMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query
                    })
                    .then(response => {
                        this.isLoadingMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.isLoadingMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),

        updateFilter: function() {
          let fCategoryId = this.categoryId;
          let fTrxDate = this.filterTransactionDate;
          let fNoteCode = this.filterNoteCode;
          let fMarkingSelected = this.markingIdSelected;

          if((fTrxDate[0] != '' && fTrxDate[0] != null) || fNoteCode != '' || (fMarkingSelected != '' && fMarkingSelected != undefined) || (fCategoryId != '' && fCategoryId != undefined)) {
            this.isSearchShow = true
          }else {
            this.isSearchShow = false
          }
        },

        getTransactionNoteAdjustmentV1: function(){

            let fCategoryId = null;
            // bank akun -> mandatory
            if(this.filterTransactionDate[0] != "" && this.filterTransactionDate[0] != null) {
                fCategoryId = this.categoryId
            } else {
                this.$Notice.warning({
                    title: "Perhatian !",
                    desc: "Silahkan pilih kategori dan tanggal terlebih dahulu",
                    duration: 5
                });

                return false
            }
            let fStartDate = null;
            let fEndDate = null;
            if(this.filterTransactionDate[0] != "" && this.filterTransactionDate[0] != null) {
                fStartDate = moment(this.filterTransactionDate[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                fEndDate = moment(this.filterTransactionDate[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }
            let fNoteCode = this.filterNoteCode != "" ? this.filterNoteCode.toUpperCase() : null;
            let fMarkingSelected = this.markingIdSelected != "" && this.markingIdSelected != undefined ? this.markingIdSelected : null;

            let payload = {
                markingHeaderId: fMarkingSelected,
                paymentDateFrom: fStartDate,
                paymentDateTo: fEndDate,
                categoryId: fCategoryId,
                noteCode: fNoteCode,
            }

            this.transactionNoteData = [];
            this.transactionNotePrint = [];
            this.$Loading.start();

            HTTP.post('transaction-note-adjustment/list', payload)
            .then(response => {
                let parent = this;
                console.log({response});

                let depositPromises = [];
                let transactionNoteDataTemp = [];

                _.forEach(response.data, function(value) {
                    let paymentDate = value.payment_date && value.payment_date != '-' ? parent.showDateFormatted(value.payment_date) : '-';
                    let bankAccount = value.bank_account ? value.bank_account.accountName : '-';
                    let amount = value.amount && value.amount != '-' ? numeral(parseFloat(value.amount)).format('0,0') : '-';
                    let marking = '';
                    let depositPendapatan = [];
                    let isSpecialMarking = false;

                    if (value.transaction_note_adjustment_detail.length > 0 && value.transaction_note_adjustment_detail[0].payment.length > 0) {
                      amount = value.transaction_note_adjustment_detail[0].payment[0] ? numeral(parent.totalAmount(value.transaction_note_adjustment_detail)).format('0,0') : '-';
                      marking = value.transaction_note_adjustment_detail[0].payment[0].marking_header ? value.transaction_note_adjustment_detail[0].payment[0].marking_header.markingheadercode : '-';

                      let prefixMarking = marking.split("/")[0];
                      isSpecialMarking = prefixMarking == 'SBR' || prefixMarking == 'SBRT' || prefixMarking == 'CTH';

                      if (value.transaction_note_adjustment_detail.length > 1) {
                        _.forEach(value.transaction_note_adjustment_detail, function(trxND) {
                          if (marking != trxND.payment[0].marking_header.markingheadercode) {
                            marking += ', ' + trxND.payment[0].marking_header.markingheadercode
                          }
                        });
                      }

                      let paymentId = value.transaction_note_adjustment_detail[0].payment[0] ? value.transaction_note_adjustment_detail[0].payment[0].id : null;
                      let paymentDate = value.transaction_note_adjustment_detail[0].payment[0] ? value.transaction_note_adjustment_detail[0].payment[0].paymentDate : null;
                      let markingHeaderId = value.transaction_note_adjustment_detail[0].payment[0] ? value.transaction_note_adjustment_detail[0].payment[0].markingHeaderId : null;

                      let payload = {
                        paymentId : paymentId,
                        transactionDate : paymentDate,
                        markingHeaderId : markingHeaderId
                      }

                      // 1. tambahkan promise untuk mengambil data deposit ke depositPromises
                      let depositPromise = HTTP.post('receivable/byParams', payload)
                          .then(response => {
                              depositPendapatan.push(response.data);
                          })
                          .catch(e => {
                              parent.$Notice.error({
                                  title: "Error",
                                  desc: e,
                                  duration: 5
                              });
                          });

                      depositPromises.push(depositPromise);
                    }

                    // 2. set trxNote ke dalam transactionNoteDataTemp setelah semua promise selesai
                    depositPromises.push(
                        Promise.all(depositPromises).then(() => {
                          let trxNote = {
                              id : value.id,
                              noteCode : value.note_code,
                              paymentDate: paymentDate,
                              bankAccount : bankAccount,
                              amount : (isSpecialMarking ? 'SGD ' : 'Rp. ') + amount,
                              marking : marking,
                              transactionNote : value,
                              depositPendapatan : depositPendapatan,
                              type : value.type
                          }
                          transactionNoteDataTemp.push(trxNote);
                        })
                    );
                });

                // 3. set semua promises selesai
                Promise.all(depositPromises).then(() => {
                  console.log({transactionNoteDataTemp});
                  parent.transactionNoteData = transactionNoteDataTemp;
                  this.$Loading.finish();
                });

            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });
        },

        getTransactionNoteAdjustment: function(){
            let fCategoryId = null;
            // bank akun -> mandatory
            if(this.filterTransactionDate[0] != "" && this.filterTransactionDate[0] != null) {
                fCategoryId = this.categoryId
            } else {
                this.$Notice.warning({
                    title: "Perhatian !",
                    desc: "Silahkan pilih kategori dan tanggal terlebih dahulu",
                    duration: 5
                });

                return false
            }
            let fStartDate = null;
            let fEndDate = null;
            if(this.filterTransactionDate[0] != "" && this.filterTransactionDate[0] != null) {
                fStartDate = moment(this.filterTransactionDate[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                fEndDate = moment(this.filterTransactionDate[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }
            let fNoteCode = this.filterNoteCode != "" ? this.filterNoteCode.toUpperCase() : null;
            let fMarkingSelected = this.markingIdSelected != "" && this.markingIdSelected != undefined ? this.markingIdSelected : null;

            let payload = {
                markingHeaderId: fMarkingSelected,
                paymentDateFrom: fStartDate,
                paymentDateTo: fEndDate,
                categoryId: fCategoryId,
                noteCode: fNoteCode,
            }

            this.transactionNoteData = [];
            this.transactionNotePrint = [];
            this.$Loading.start();

            HTTP.post('transaction-note-adjustment/list', payload)
            .then(response => {
                let parent = this;
                console.log({response});

                let transactionNoteDataTemp = [];

                _.forEach(response.data, function(value) {
                    let paymentDate = value.payment_date && value.payment_date != '-' ? parent.showDateFormatted(value.payment_date) : '-';
                    // let bankAccount = value.bank_account ? value.bank_account.accountName : '-';
                    // let amount = value.amount && value.amount != '-' ? numeral(parseFloat(value.amount)).format('0,0') : '-';
                    let amount = value.amount && value.amount != '-' ? value.amount : '-';
                    let marking = '-';
                    let isSpecialMarking = false;

                    if (value.transaction_note_adjustment_detail.length > 0 && value.transaction_note_adjustment_detail[0].payment.length > 0) {
                      // amount = value.transaction_note_adjustment_detail[0].payment[0] ? numeral(parent.totalAmount(value.transaction_note_adjustment_detail)).format('0,0') : '-';
                      amount = value.transaction_note_adjustment_detail[0].payment[0] ? parent.totalAmount(value.transaction_note_adjustment_detail) : '-';
                      marking = value.transaction_note_adjustment_detail[0].payment[0].marking_header ? value.transaction_note_adjustment_detail[0].payment[0].marking_header.markingheadercode : '-';

                      let prefixMarking = marking.split("/")[0];
                      isSpecialMarking = prefixMarking == 'SBR' || prefixMarking == 'SBRT' || prefixMarking == 'CTH';

                      if (value.transaction_note_adjustment_detail.length > 1) {
                        _.forEach(value.transaction_note_adjustment_detail, function(trxND) {
                          if (marking != trxND.payment[0].marking_header.markingheadercode) {
                            marking += ', ' + trxND.payment[0].marking_header.markingheadercode
                          }
                        });
                      }
                    }

                    console.log({amount});

                    let trxNote = {
                        trx_note_adjustment_id : value.id,
                        noteCode : value.note_code,
                        paymentDate: paymentDate,
                        // bankAccount : bankAccount,
                        amount: isSpecialMarking ? 'SGD ' + (parseFloat(String(amount).replace(/,/g, '')) || 0).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) : 'Rp. ' + numeral(parseFloat(amount)).format('0,0'),
                        marking : marking,
                        type : value.type
                    }

                    console.log({trxNote});

                    transactionNoteDataTemp.push(trxNote);
                });

                parent.transactionNoteData = transactionNoteDataTemp;
                this.$Loading.finish();
            })
            .catch(e => {
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });
        },

        onSelectionChange:function(selection){
          console.log({selection});
          this.transactionNotePrint = selection
        },

        showModalConfirmMultiplePrint: function(dataSelected){
          // cek -> apakah ada data yg belum melakukan pembayaran
          let isPaymentAll = true;

          this.modalConfirmMultiplePrint = isPaymentAll ? true : false;
        },

        notePrintV1(dataTrx) {
          console.log({dataTrx});
          this.isPrinting = true
          let parent = this

          // ---------- INI UNTUK HANDLE SISA TAGIHAN
            // temp all data payment_allocate & get data groupByInvoiceDueId
            const paymentAllocatesTemp = []
            dataTrx.forEach(el => {
              el.transactionNote.transaction_note_adjustment_detail.forEach(function(tnd) {
                tnd.payment.forEach(function(payment) {
                  payment.payment_allocate.forEach(function(payment_allocate) {
                    let temp = {
                      payment_allocate : payment_allocate,
                      noteCode : el.transactionNote.note_code,
                      paymentId : payment.id,
                      paymentDate : payment.paymentDate
                    }
                    paymentAllocatesTemp.push(temp);
                  });
                });
              })
            });

            console.log({paymentAllocatesTemp});

            // get payments paymentIds from payment_allocates - promises untuk semua permintaan HTTP
            const paymentIds = []
            const promises = paymentAllocatesTemp.map((el, index) => {
              // HTTP GET untuk 'transaction-note/get-payment-allocates/'
              const getAllocatePromise = HTTP.get(
                "transaction-note/get-payment-allocates/" + el.payment_allocate.invoiceDueId
              )
                .then((response) => {
                  const data = response.data;
                  // console.log({data});

                  if (data.length > 0) {
                    let totalAllocateAmountBefore = 0;
                    let receivableRemainingBefore =
                      // el.payment_allocate.invoice_due_detail.receivableRemaining;
                      el.payment_allocate.invoice_due_detail.receivable_detail.type !== 'MAN' ?
                        el.payment_allocate.invoice_due_detail.receivable_detail.debitAmount : 0;

                    // console.log({receivableRemainingBefore});
                    // console.log('el.payment_allocate.paymentId: ', el.payment_allocate.paymentId);
                    // console.log('el.payment_allocate.invoiceDueId: ', el.payment_allocate.invoiceDueId);

                    // Sum total allocate sebelumnya, break jika sudah ketemu paymentId yg dicari
                    for (const map of data) {
                      if (
                        el.payment_allocate.paymentId === map.paymentId &&
                        el.payment_allocate.invoiceDueId === map.invoiceDueId
                      ) {
                        totalAllocateAmountBefore += parseFloat(map.allocateAmount);
                        break;
                      }
                      totalAllocateAmountBefore += parseFloat(map.allocateAmount);
                      receivableRemainingBefore -= parseFloat(map.allocateAmount);
                    }

                    return {
                      index,
                      paymentAllocateId: el.payment_allocate.id,
                      paymentId: el.payment_allocate.paymentId,
                      allocateAmount: el.payment_allocate.allocateAmount,
                      totalAllocateAmountBefore,
                      receivableRemainingBefore,
                      prevNoteCode: el.noteCode,
                      receivableRemaining: el.payment_allocate.invoice_due_detail.receivableRemaining
                    };
                  }

                  return null;
                })
                .catch((e) => {
                  this.$Notice.error({
                    title: "Error",
                    desc: e.message || e,
                    duration: 5,
                  });
                  return null;
                });

              // HTTP POST untuk 'transaction-note/get-receivable-paymentsum'
              const payloadX = {
                paymentId: el.paymentId,
                paymentDate: el.paymentDate,
              };

              const postReceivablePromise = HTTP.post("transaction-note/get-receivable-paymentsum", payloadX)
                .then((response) => {
                  const data = response.data;
                  return data; // Kembalikan data jika dibutuhkan
                })
                .catch((e) => {
                  this.$Notice.error({
                    title: "Error",
                    desc: e.message || e,
                    duration: 5,
                  });
                  return null;
                });

              // Gabungkan kedua promise dengan Promise.all
              return Promise.all([getAllocatePromise, postReceivablePromise]).then(
                ([allocateData, receivableData]) => {
                  return {
                    allocateData, // Data dari GET
                    receivableData, // Data dari POST
                    index, // Tambahkan index jika diperlukan
                  };
                }
              );
            });
          // ---------- END INI UNTUK HANDLE SISA TAGIHAN

          Promise.all(promises)
          .then((results) => {
            // console.log({results});
            // Filter out null values dan urutkan berdasarkan index, handle urutan promises
            const sortedResults = results
              .filter(result => result !== null)
              .sort((a, b) => a.index - b.index);
            paymentIds.push(...sortedResults);

            console.log({paymentIds});

            let payloadToExcel = {
              dataTrx: dataTrx,
              paymentIds: paymentIds
            }

            console.log({payloadToExcel});

            HTTP.post('transaction-note-adjustment/print-to-excel', payloadToExcel, {
              responseType: 'blob'
            })
            .then(response => {
              const blob = new Blob([response.data], {
                type: 'application/vnd.ms-excel'
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', `${dataTrx.length > 1 ? 'NT' : 'NT - ' + dataTrx[0].noteCode}` + ` - ${moment(new Date()).format("DDMMYYhhmmss")}.xls`); // name file downloaded
              document.body.appendChild(link);
              link.click();
              link.remove();
            })

            this.isPrinting = false;
          })
          .catch(e => {
            console.error('Error in one of the API calls:', e);
            this.isPrinting = false
          });
        },

        notePrint(dataTrx) {
          console.log({dataTrx});
          // this.isPrinting = true

          let trxNoteAdjustmentIds = dataTrx.map(item => item.trx_note_adjustment_id)

          console.log({trxNoteAdjustmentIds});

          HTTP.post('transaction-note-adjustment/get-detail', { trxNoteAdjustmentIds }, {
            responseType: 'blob'
          })
          .then(response => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.ms-excel'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${dataTrx.length > 1 ? 'NT' : 'NT - ' + dataTrx[0].noteCode}` + ` - ${moment(new Date()).format("DDMMYYhhmmss")}.xls`); // name file downloaded
            document.body.appendChild(link);
            link.click();
            link.remove();

            this.isPrinting = false;
          })
        },

        noteDelete(dataTrx) {
          this.isDelete = true;

          HTTP.post('transaction-note/delete', {dataTrx})
            .then(response => {
                console.log({response});

                if (response.data) {
                  this.$Message.success('Nota transaksi berhasil dihapus !');
                  this.isDelete = false
                  this.transactionNotePrint = []
                  this.modalConfirmMultipleDelete = false
                  this.getTransactionNoteAdjustment();
                }
            })
            .catch(e => {
                this.isDelete = false
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });

        }
    },

    mounted() {
        this.$Loading.config({
            color: '#ffffff',
            failedColor: '#f0ad4e',
            height: 10
        });

        this.getCategories();
    }
}

</script>



// WEBPACK FOOTER //
// PaymentTransactionNoteAdjustment.vue?36e6aa9e